function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import styles from './styles.module.scss';
import Button from '@profile/src/Components/Button';
import Modal from '@profile/src/Components/PopupModal_V2';
import { useTestId } from '@wolffun/testable-id';
import icThetanRivals from '@profile/assets/img/thetan_rivals_logo.png';
import icArrow from '@profile/assets/svg/ic_arrow_blue.svg';
import imgGameDevice from '@profile/assets/img/img_game_device.png';
import imgGift from '@profile/assets/img/img_gift.png';

const ConnectWalletCampaignModal = ({
  onClose
}) => {
  const {
    generateTestIdProps
  } = useTestId();
  return /*#__PURE__*/React.createElement(Modal, _extends({}, generateTestIdProps('close-button'), {
    className: styles.modal,
    onClose: onClose
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Congratulation"), /*#__PURE__*/React.createElement("span", {
    className: styles.desc
  }, "You have successfully connected your wallet, your reward is waiting for you."), /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.card
  }, /*#__PURE__*/React.createElement("img", {
    src: icThetanRivals
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.text
  }, "Download", /*#__PURE__*/React.createElement("br", null), "Thetan Rivals")), /*#__PURE__*/React.createElement("img", {
    src: icArrow,
    className: styles.icArrow
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.card
  }, /*#__PURE__*/React.createElement("img", {
    src: imgGameDevice
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.text
  }, "Start Game")), /*#__PURE__*/React.createElement("img", {
    src: icArrow,
    className: styles.icArrow
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.card
  }, /*#__PURE__*/React.createElement("img", {
    src: imgGift
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.text
  }, "Claim Reward"))), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Button, _extends({}, generateTestIdProps('i-got-it-button'), {
    onClick: onClose,
    className: styles.btn,
    title: "I Got It"
  }))));
};

export default ConnectWalletCampaignModal;